<div class="container breathe size map-host" [class.has-detail-panel]="showDetailPanel">
  <div #map id="map" class="container"></div>

  @if (showDetailPanel) {
    <aside class="map-side-panel" role="complementary" aria-label="Map details" (click)="$event.stopPropagation()">
      <button class="panel-close" type="button" (click)="closeDetailPanel()" aria-label="Close map details">&times;</button>

      <div class="panel-body">
        @if (isLandlinePointDetails) {
          <div class="landline-grid landline-header" role="row">
            <span role="columnheader">{{ 'Provider' | label | async }}</span>
            <span role="columnheader">{{ 'Technology' | label | async }}</span>
            <span role="columnheader">{{ 'Download' | label | async }}</span>
            <span role="columnheader">{{ 'Upload' | label | async }}</span>
          </div>

          @for (detail of landlineRows; track $index) {
            <section class="landline-group">
              <div class="landline-grid landline-row" role="row">
                <span role="cell"><span class="landline-pill">{{ detail.provider || '-' }}</span></span>
                <span role="cell"><span class="landline-pill">{{ detail.technology || '-' }}</span></span>
                <span role="cell"><span class="speed-pill" [style.background-color]="getBackgroundColor(detail.download)">{{ detail.download || '-' }}</span></span>
                <span role="cell"><span class="speed-pill" [style.background-color]="getBackgroundColor(detail.upload)">{{ detail.upload || '-' }}</span></span>
              </div>
              @if (detail.operators) {
                <div class="landline-operators">{{ detail.operators }}</div>
              }
            </section>
          }
        } @else {
          <ul class="panel-list">
            @for (detail of olMapService.details; track detail) {
              <li>
                <span class="label">
                  @if (detail.label) { {{ detail.label | label | async }} }
                  @else if (detail.level) { {{ detail.level | level | async }} }
                </span>
                <span class="value">
                  @if (detail.value != null) { {{ detail.value }} }
                  @else if (detail.ratio != null) { {{ detail.ratio | multiply : 100 | number : '1.0-2' }}% }
                </span>
              </li>
            }
          </ul>
        }
      </div>
    </aside>
  }

  <router-outlet></router-outlet>
</div>